import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=673a6b1c&"
import script from "./Stores.vue?vue&type=script&lang=ts&"
export * from "./Stores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports